import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const deactivateMerchantGroupUser = async (
  userId: string
) => {
  await api.post(
    `/merchant-group/users/${userId}/deactivate/`,
    { isMerchantGroup: true }
  )
  queryClient.invalidateQueries([
    BASE_MERCHANT_GROUP_USERS_QUERY_KEY,
  ])
}
